module.exports = __webpack_public_path__ + "img/187w.86464e9.jpg";